import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { catchError, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CaseDetails, Case, AttachmentsDetails, ArrAttachmentsDetails, Results, DealerInfo } from './case-details';
import { CastExpr } from '@angular/compiler';

@Injectable({
  providedIn: 'root'
})
export class FetchdataServiceService {

  constructor(private http: HttpClient) { }


  getData(url: string): Observable<any> {
    return this.http.get(url);
  }

  validatevin(url: string, vin: string): Observable<any> {
    return this.http.get(url + '/' + vin, this.httpOptions).pipe(catchError(this.handleError));
  }

  postData(url: string, body: Case): Observable<any> {

    return this.http.post(url, body, this.httpOptions).pipe(catchError(this.handleError));
  }

  postDealerInfoData(url: string, body: DealerInfo): Observable<any> {

    return this.http.post(url, body, this.httpOptions).pipe(catchError(this.handleError));
  }

  postSearchData(url: string, body: Case): Observable<any> {

    //return this.http.post(url, body, this.httpOptions).pipe(map(items => items.map(item => new CaseDetails(item)))).subscribe(...);
    return this.http.post(url, body, this.httpOptions).pipe(catchError(this.handleError));
  }

  postFiles(url: string, formData: FormData): Observable<any> {
    var options = { content: formData };

    var httpOptionsFile: any = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Content-Length': '26792',
        'Authorization': 'Basic ' + btoa('kciuser:Sti$enger!!"'),
        'Access-Control-Allow-Origin': '*'
      }), 'content': formData
    };


    return this.http.post(url, formData).pipe(catchError(this.handleError));

    //return this.http.post<File>(url, formData, { headers: { 'Content-Type': 'undefined' } });
  }

  params = new HttpParams();

  httpOptions: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Basic ' + btoa('kciuser:Sti$enger!!"'),
      'Access-Control-Allow-Origin': '*'
    })
  };




  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      //console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      //console.error(
      // `Backend returned code ${error.status}, ` +
      //`body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      '300');
  };

}
